import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { filter, first, tap } from 'rxjs/operators';
import { AppState, NO_SCROLL } from 'src/app';
import { GeolocationService } from 'src/core';
import { PERMISSION_STATES, PermissionState } from '@models/permission.class';
@Component({
  selector: 'hb-geolocation',
  templateUrl: 'geolocation.component.html',
  styleUrls: ['./geolocation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GeolocationComponent implements OnInit, OnDestroy {
  public readonly PROMPT_MODAL_ID = 'geolocation-modal-prompt';
  public readonly DENIED_MODAL_ID = 'geolocation-modal-denied';
  public readonly permissionStates = PERMISSION_STATES;

  public geolocationState$: Observable<PermissionState>;
  public isModalOpen: boolean;

  public showTooltip = false;
  public readonly GEOLOCATION_INFO: string = `Por regulación es necesario
    obtener la ubicación del dispositivo mediante el cual realizarás
    operaciones a través de GBM y de esta manera cumplir la normatividad
    a la cual está sujeta esta Casa de Bolsa.`;

  private showInformationSubscription = Subscription.EMPTY;

  constructor(
    private store: Store<AppState>,
    private geolocationService: GeolocationService,
  ) {}

  ngOnInit() {
    this.getGeolocationPermissionsState();
    this.createInformationTogglerSubscription();

    this.openModal();
  }

  ngOnDestroy() {
    this.closeModal();

    this.showInformationSubscription.unsubscribe();
  }

  public openModal(): void {
    this.getGeolocationPermissionsState();

    this.isModalOpen = true;
    this.updateBodyScroll();

    this.geolocationState$
      .pipe(
        first(),
        filter(
          (permissionState) => permissionState === PERMISSION_STATES.prompt,
        ),
      )
      .subscribe(() => this.geolocationService.promptToEnableGeolocation$());
  }

  public closeModal() {
    this.isModalOpen = false;
    this.updateBodyScroll();
  }

  /**
   * This enables/disables the vertical scroll on the body
   */
  private updateBodyScroll() {
    this.store.dispatch({
      type: NO_SCROLL,
      payload: { block: this.isModalOpen, source: 'GeolocationComponent' },
    });
  }

  private createInformationTogglerSubscription() {
    this.showInformationSubscription =
      this.geolocationService.showNotice$.subscribe(
        (shouldDisplayInformation) =>
          shouldDisplayInformation ? this.openModal() : this.closeModal(),
      );
  }

  private getGeolocationPermissionsState() {
    this.geolocationState$ = this.geolocationService.permissionsState$
      .asObservable()
      .pipe(
        first(),
        tap(
          (permissionState) =>
            permissionState === PERMISSION_STATES.granted && this.closeModal(),
        ),
      );
  }
}
